import { render, staticRenderFns } from "./StaffDetails.vue?vue&type=template&id=753a4b5f&scoped=true"
import script from "./StaffDetails.vue?vue&type=script&lang=js"
export * from "./StaffDetails.vue?vue&type=script&lang=js"
import style0 from "./StaffDetails.vue?vue&type=style&index=0&id=753a4b5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753a4b5f",
  null
  
)

export default component.exports